import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { setPageName } from "../../../actions";
import { getLastDataRefresh } from "../../../api/JourneyExcellenceMarketPerformanceSummary";
import "../../../assets/styles/pages/marketPerformanceSummary.scss";
import MarketPerformanceSummaryFilters from "../../../components/Filters/JourneyExcellence/MarketPerformanceSummaryFilters";
import { DashboardLayout } from "../../../components/Layouts";
import { DefaultPageContent } from "../../../components/PageContent";
import { PageTitle } from "../../../components/PageContent/subs";
import { JOURNEY_EXCELLENCE_BTN_FILTERS } from "../../../constants/journeyExcellenceConstants";
import KbasAndLeads from "./components/KbasAndLeads";
import MediaFmiAndCoreModel from "./components/MediaFmiAndCoreModel";
import MediaFMIAndRetailSales from "./components/MediaFMIAndRetailSales";
import MediaFmiJourney from "./components/MediaFmiJourney";
import QualifiedVisitsAndKbas from "./components/QualifiedVisitsAndKbas";
import SearchInterestBrandAndModel from "./components/SearchInterestBrandAndModel";

const JourneyExcellenceMarketPerformanceSummary = withRouter((props: RouteComponentProps) => {
  const { history } = props;
  const dispatch = useDispatch();

  const { data: lastDataRefreshData, refetch: refetchLastDataRefresh } = useQuery({
    queryKey: ["marketPerformanceSumaryLastDataRefresh"],
    queryFn: getLastDataRefresh,
    enabled: false,
  });

  useEffect(() => {
    refetchLastDataRefresh();
  }, [history.location.search]);

  useEffect(() => {
    dispatch(setPageName("Market Performance Summary"));
  }, []);

  return (
    <DashboardLayout>
      <DefaultPageContent
        filter={<MarketPerformanceSummaryFilters filterBtns={JOURNEY_EXCELLENCE_BTN_FILTERS} />}
        dataDocumentation="marketing_performance_summary"
        lastDataRefresh={lastDataRefreshData?.date ?? ""}
        pageTitle={<PageTitle dataDocumentation="marketing_performance_summary" />}
      >
        <div className="market-performance-summary">
          <MediaFMIAndRetailSales />
          <MediaFmiJourney />
          <MediaFmiAndCoreModel />
          <SearchInterestBrandAndModel />
          <QualifiedVisitsAndKbas />
          <KbasAndLeads />
        </div>
      </DefaultPageContent>
    </DashboardLayout>
  );
});

export default JourneyExcellenceMarketPerformanceSummary;
